/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";
import dashboardData from "../../mocks/dashboard/response_exmaple/dashboard.json";
import { StatisticsParams } from "#/types/xecguard";

// eslint-disable-next-line prefer-destructuring
const USE_MOCK = process.env.USE_MOCK;

export type StatisticsRequestType = {
  params: StatisticsParams;
  token: string;
};

export type StatisticsType = {
};

export default function getStatistics({ params, token }: StatisticsRequestType): Promise<InternalResponse> {
  if (USE_MOCK) {
    console.log("[Mock] Returning mock statistics data");
    // Ensure mock data matches the StatisticsResponse type
    // dashboard.json structure might need mapping or assuming it matches
    return Promise.resolve({
      success: true,
      statusCode: 200,
      data: {
        request_statistics: {
          service_token_id: "mock_token",
          start_at: params.start_at,
          end_at: params.end_at,
          total_requests: 600,
          blocked_requests: 430,
          block_rate: 0.71,
          violated_types: {
            VIOLATION_HARMFUL: 102,
            VIOLATION_SYSTEM_PROMPT: 166,
            VIOLATION_CUSTOMIZED_RULE: 66,
            VIOLATION_CONTEXT_GROUNDING: 1,
            VIOLATION_GENERAL_PROMPT: 95,
            VIOLATION_PII: 20,
          },
          blocked_requests_by_max_risk: {
            3: 210, 4: 120, 2: 80, 1: 20,
          },
        },
        request_latency_metrics: {
          avg_response_time_ms: 45,
          max_response_time_ms: 120,
          p95_response_time_ms: 80,
          p99_response_time_ms: 100,
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        unsafe_request_records: dashboardData.threatTrace.map((t: any) => ({
          service_token_id: "mock_token",
          trace_id: t.traceId,
          route: "/mock/route",
          violated_types: ["VIOLATION_CUSTOMIZED_RULE"],
          violated_policy_names: t.policies || [],
          timestamp: t.time,
        })),
        api_errors: [],
      },
    });
  }

  return request()({
    url: "/xecguard/v1/stats",
    method: "GET",
    params,
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<StatisticsType>): InternalResponse<StatisticsType> => ({
      statusCode: result.status,
      data: result.data,
      tokenId: params.service_token_id,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
